<template>
  <div class="login-container">
    <div class="login-bg"></div>
    <div class="login-content">
      <div class="login-left">
        <div class="brand-badge">
          <img src="@/assets/logo.svg" alt="知会云logo" class="brand-logo" />
          <div class="brand-name">
            <div class="brand-title">知会云校园</div>
            <div class="brand-subtitle">Zhihuiyun Campus</div>
          </div>
        </div>
        <div class="slogan">
          <h2>让数据驱动每一次教学决策</h2>
          <p>面向学校的教研、考试、资源建设与运营一体化平台。</p>
        </div>
        <ul class="feature-list">
          <li>实时考试与学情数据可视化</li>
          <li>统一资源与题库管理中心</li>
          <li>多校多级权限与精细化管控</li>
        </ul>
      </div>
      <div class="login-right">
        <div class="login-panel">
          <div class="panel-header">
            <div class="panel-logo-wrap">
              <img src="@/assets/logo.svg" alt="知会云logo" class="panel-logo" />
            </div>
            <div class="panel-title">账号登录</div>
            <div class="panel-subtitle">使用后台账号登录管理控制台</div>
          </div>
          <el-form :model="form" :rules="rules" ref="loginForm" label-position="top">
            <el-form-item label="账号" prop="username">
              <el-input
                v-model="form.username"
                autocomplete="off"
                size="medium"
                placeholder="请输入账号"
              />
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                v-model="form.password"
                type="password"
                autocomplete="off"
                size="medium"
                placeholder="请输入密码"
                show-password
              />
            </el-form-item>
            <div class="login-extra">
              <el-checkbox v-model="form.remember">记住我</el-checkbox>
              <span class="forget-text">忘记密码？请联系管理员重置</span>
            </div>
            <el-button
              type="primary"
              size="medium"
              :loading="loading"
              @click="handleLogin"
              class="login-btn"
            >
              立即登录
            </el-button>
          </el-form>
          <div class="panel-footer">
            © {{ new Date().getFullYear() }} 知会云 · All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
        remember: true
      },
      loading: false,
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },
  mounted() {
    document.title = '知会云校园';
  },
  methods: {
    ...mapActions('user', ['login']),
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        try {
          const res = await this.login(this.form);
          if (res && res.code === 0) {
            const redirect = this.$route.query.redirect || '/';
            this.$router
              .replace(redirect)
              .catch(() => {
                // 忽略因导航重定向导致的非致命错误
              });
          }
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at 0 0, #40a9ff33 0, transparent 50%),
    radial-gradient(circle at 100% 100%, #1677ff33 0, transparent 50%),
    linear-gradient(135deg, #f0f5ff 0%, #ffffff 40%, #f0f2f5 100%);
  position: relative;
  overflow: hidden;
}

.login-bg {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(120deg, rgba(22, 119, 255, 0.08) 0%, transparent 60%);
  pointer-events: none;
}

.login-content {
  position: relative;
  z-index: 1;
  width: 920px;
  max-width: 96%;
  display: flex;
  border-radius: 20px;
  box-shadow: 0 30px 80px rgba(15, 35, 95, 0.18);
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(18px);
}

.login-left {
  flex: 1;
  padding: 40px 40px 40px 44px;
  background: linear-gradient(140deg, #1677ff 0%, #40a9ff 40%, #69c0ff 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.brand-badge {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
}

.brand-logo {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  margin-right: 16px;
}

.brand-name {
  display: flex;
  flex-direction: column;
}

.brand-title {
  font-size: 22px;
  font-weight: 600;
}

.brand-subtitle {
  font-size: 13px;
  opacity: 0.9;
  margin-top: 4px;
}

.slogan h2 {
  font-size: 22px;
  margin: 0 0 12px;
}

.slogan p {
  margin: 0;
  font-size: 14px;
  opacity: 0.96;
}

.feature-list {
  margin: 28px 0 0;
  padding: 0;
  list-style: none;
  font-size: 13px;
  opacity: 0.96;
}

.feature-list li {
  margin-bottom: 8px;
  position: relative;
  padding-left: 16px;
}

.feature-list li::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e6f7ff;
  position: absolute;
  left: 0;
  top: 8px;
}

.login-right {
  width: 380px;
  padding: 32px 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-panel {
  width: 100%;
}

.panel-header {
  text-align: center;
  margin-bottom: 24px;
}

.panel-logo-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: linear-gradient(135deg, #1677ff 0%, #40a9ff 100%);
  box-shadow: 0 12px 30px rgba(22, 119, 255, 0.4);
  margin-bottom: 12px;
}

.panel-logo {
  width: 40px;
  height: 40px;
  border-radius: 12px;
}

.panel-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 4px;
}

.panel-subtitle {
  font-size: 13px;
  color: #8c8c8c;
}

.login-extra {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0 16px;
  font-size: 12px;
  color: #8c8c8c;
}

.forget-text {
  cursor: default;
}

.login-btn {
  width: 100%;
  margin-top: 4px;
}

.panel-footer {
  margin-top: 18px;
  text-align: center;
  font-size: 12px;
  color: #bfbfbf;
}

@media (max-width: 960px) {
  .login-content {
    flex-direction: column;
    width: 94%;
  }

  .login-left {
    display: none;
  }

  .login-right {
    width: 100%;
    padding: 28px 24px 24px;
  }
}
</style>

